export default __webpack_public_path__ + "static/media/direct-mail-disabled.5a48106a.svg";